import { Flex, Text, Title } from '@tremor/react'
import { useEffect } from 'react'
import { CheckIcon } from '@heroicons/react/24/outline'
import { useApiV1BillingCheckoutCallbackCreate } from '../../api/api.gen'

export default function BillingSuccessfulPage() {
    const { response, sendNowWithParams } =
        useApiV1BillingCheckoutCallbackCreate('', {}, false)

    useEffect(() => {
        if (
            (window.localStorage.getItem('checkout_session_id') || '').length >
            0
        ) {
            sendNowWithParams(
                window.localStorage.getItem('checkout_session_id') || '',
                {}
            )
            window.localStorage.removeItem('checkout_session_id')
        }
    }, [])

    return (
        <Flex
            className="p-4 bg-gray-50 w-auto min-w-[1000px] max-w-fit mt-4 rounded-md"
            flexDirection="col"
            justifyContent="start"
            alignItems="start"
        >
            <Flex
                flexDirection="col"
                alignItems="center"
                justifyContent="center"
            >
                <CheckIcon className="bg-green-600 text-white rounded-full w-20 h-20 p-3 my-6" />
                <Title className="w-fit text-teal-600 mb-2">
                    Payment Succeeded
                </Title>
                <Text className="w-fit text-gray-600  mb-6">
                    {((response?.amountInBaisa || 0) / 1000.0).toFixed(3)} OMR
                    has been added to your account.
                </Text>
            </Flex>
        </Flex>
    )
}
